export const DEFAULT_LANGUAGE = "ca";

export const SUPPORTED_LANGUAGES = ["en", "ca", "es"];

export const LANGUAGE_STORAGE_KEY = "app_language";

export function normalizeLanguage(input) {
  if (!input || typeof input !== "string") {
    return DEFAULT_LANGUAGE;
  }

  const normalized = input.toLowerCase();
  const directMatch = SUPPORTED_LANGUAGES.find((lang) => lang === normalized);

  if (directMatch) {
    return directMatch;
  }

  const baseLanguage = normalized.split("-")[0];
  const baseMatch = SUPPORTED_LANGUAGES.find((lang) => lang === baseLanguage);

  return baseMatch || DEFAULT_LANGUAGE;
}
